import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Logo from "../assets/nutrackx.png";
const generatePDF = async (data, name, fromDate, toDate) => {
  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const logo = new Image();
  logo.src = Logo;

  await new Promise((resolve) => (logo.onload = resolve));

  const summaryHeaders = [
    "Name",
    "TDays",
    "TPresent",
    "TAbsent",
    "TLeave",
    "TLate",
    "THoliday",
    "Fuel Days",
    "Total Hours"
  ];

  let tableBody = [];

  // Iterate over departments
  Object.keys(data).forEach((dept) => {
    tableBody.push([{ content: dept, colSpan: 9, styles: { halign: "center", fillColor: [200, 200, 200], textColor: "#000", } }]);

    data[dept].forEach((emp) => {
      let totalHours = 0;
      let totalMinutes = 0;
      let totalLate = 0;
      let totalAbsent = 0;
      let totalPresent = 0;
      let totalHoliday = 0;
      let totalLeave = 0;
      let totalDays = 0;

      (emp.attendanceData || []).forEach((attendance) => {
        if (attendance.totalHours) {
          const [h, m] = attendance.totalHours.split(":").map(Number);
          totalHours += h || 0;
          totalMinutes += m || 0;
        }
        if (attendance.late === "Late") totalLate++;
        if (attendance.entryTime) totalPresent++;
        if (attendance.dayType === "Absent") totalAbsent++;
        if (attendance.dayType === "Leave") totalLeave++;
        if (
          !attendance.entryTime &&
          attendance.dayType === "Holiday" &&
          attendance.remark !== "SATURDAY" &&
          attendance.remark !== "SUNDAY"
        ) {
          totalHoliday++;
        }
        if (attendance?.entryTime || (attendance.dayType !== "Weekend" &&
          attendance.remark !== "SATURDAY" &&
          attendance.remark !== "SUNDAY")) {
          totalDays += 1
        }
      });

      totalHours += Math.floor(totalMinutes / 60);
      totalMinutes %= 60;

      const fuelDays = totalPresent - totalLate;

      tableBody.push([
        emp.firstname || "Unknown",
        totalDays,
        totalPresent,
        totalAbsent,
        totalLeave,
        totalLate,
        totalHoliday,
        fuelDays,
        totalHours
      ]);
    });
  });

  autoTable(doc, {
    head: [summaryHeaders],
    body: tableBody,
    margin: { top: 25 },
    styles: {
      fontSize: 9,
      halign: "center",
      valign: "middle",
    },
    headStyles: {
      fillColor: ["#fff"], // Dark blue/gray background
      textColor: "#000", // White text
      fontStyle: "bold"
    },
    didDrawPage: (data) => {
      // Header (Logo, Title, Date)
      doc.addImage(logo, "PNG", 4, -5, 40, 30);
      doc.setFontSize(14);
      doc.text("Monthly Employee Report", pageWidth / 2, 13, { align: "center" });
      doc.setFontSize(10);
      doc.text(`(${fromDate} - ${toDate})`, pageWidth - 10, 13, { align: "right" });

      // Footer
      const pageCount = doc.internal.getNumberOfPages();
      const pageStr = `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`;
      doc.setFontSize(8);
      doc.text(pageStr, pageWidth - 20, pageHeight - 5);
      doc.text(`Printed on: ${new Date().toLocaleString("en-GB")}`, 10, pageHeight - 5);
    },
  });

  doc.save(`${name == "All" ? "All" : name}.pdf`);
};

export default generatePDF;